import {
  Apps,
  Group,
  PermDeviceInformation,
  PlaylistAddCheck,
  QuestionAnswer,
  Reddit,
  Reorder,
  Send,
  Settings,
  Web,
  RocketLaunch,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import {
  CHATS,
  CLIENT_CONFIGURATION,
  CONFIGURATION,
  DASHBOARD,
  MESSAGES,
  NOTIFICATIONS,
  SPECIALTIES,
  REMINDERS,
  TEMPLATES,
  TRAINING,
  USERS,
  CHANNELS,
  ONBOARDING,
} from '../constants/routes';

export default function useRoutes(props) {
  const profile = useSelector((state) => state.firebase.profile);
  const organization = useSelector((state) => state.app.organization);
  const availableRoutes = props && props.routes;

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');
  const isOrganizationAdmin =
    profile && profile.claims && profile.claims.includes('organizationAdmin');
  const notificationsService =
    organization && organization.services && organization.services.notifications;
  const altaService = organization && organization.services && organization.services.altaTemplate;
  const activationService =
    organization && organization.services && organization.services.activationTemplate;

  const routes = [
    (!availableRoutes || availableRoutes.includes(DASHBOARD)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Dashboard',
        path: DASHBOARD,
        icon: <Apps />,
      },
    (!availableRoutes || availableRoutes.includes(USERS)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Usuarios',
        path: USERS,
        icon: <Group />,
      },
    (!availableRoutes || availableRoutes.includes(CHATS)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Chats',
        path: CHATS,
        icon: <Send />,
      },
    (!availableRoutes || availableRoutes.includes(MESSAGES)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Mensajes del Sistema',
        path: MESSAGES,
        icon: <QuestionAnswer />,
      },
    (!availableRoutes || availableRoutes.includes(CHANNELS)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Webchat & Whatsapp',
        path: CHANNELS,
        icon: <Web />,
      },
    (!availableRoutes || availableRoutes.includes(TEMPLATES)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Plantillas',
        path: TEMPLATES,
        icon: <Reorder />,
      },
    (!availableRoutes || availableRoutes.includes(NOTIFICATIONS)) &&
      (notificationsService ||
        altaService ||
        activationService ||
        organization.id === 'yvFOV3r2X73cffXra4sH') &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Notificaciones',
        path: NOTIFICATIONS,
        icon: <PermDeviceInformation />,
      },
    (!availableRoutes || availableRoutes.includes(REMINDERS)) &&
      notificationsService &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Recordatorios',
        path: REMINDERS,
        icon: <PlaylistAddCheck />,
      },
    (!availableRoutes || availableRoutes.includes(CLIENT_CONFIGURATION)) &&
      (isAdmin || isOrganizationAdmin) && {
        adminRoutes: false,
        label: 'Configuración',
        path: CLIENT_CONFIGURATION,
        icon: <Settings />,
      },
    (!availableRoutes || availableRoutes.includes(SPECIALTIES)) &&
      isAdmin && {
        adminRoutes: true,
        label: 'Especialidades',
        path: SPECIALTIES,
        icon: <PlaylistAddCheck />,
      },
    (!availableRoutes || availableRoutes.includes(TRAINING)) &&
      isAdmin && {
        adminRoutes: true,
        label: 'Entrenamiento',
        path: TRAINING,
        icon: <Reddit />,
      },
    (!availableRoutes || availableRoutes.includes(ONBOARDING)) &&
      isAdmin && {
        adminRoutes: true,
        label: 'Onboarding',
        path: ONBOARDING,
        icon: <RocketLaunch />,
      },
    (!availableRoutes || availableRoutes.includes(CONFIGURATION)) &&
      isAdmin && {
        adminRoutes: true,
        label: 'Configuración',
        path: CONFIGURATION,
        icon: <Settings />,
      },
  ];

  return routes.filter((e) => e);
}
